import AuthClient from "@/API/AuthClient";
import httpClient from "@/API/HttpClient";

const login = (params) =>
  AuthClient.post(`authenticate`, params, {
    headers: {
      "Content-Type": "application/json",
    },
  });

const schedule = (search) => httpClient.get(`schedule`, { params: { search } });
const getCategory = () => httpClient.get(`Category`);
const getReportCustomer = (pageNumber, customerId, ordersho, permSho) =>
  httpClient.get(
    `PermissionOutput?pageSize=10&includeCount=true&pageNumber=${pageNumber}&customerId=${customerId}&ordersho=${ordersho}&permSho=${permSho}`
  );
const getOrders = (pageNumber, date) =>
  httpClient.get(
    `/Orders?PageNumber=${pageNumber}&PageSize=10&IncludeCount=true&basketdate=${date}`
  );

const getAddress = (id) => httpClient.get(`Address?custid=${id}`);
const updatePermissionOutput = (permId, ordersho, flags) => {
  return httpClient.post(
    `PermissionOutput?permId=${permId}&ordersho=${ordersho}`,
    flags
  );
};

const postAddress = (id, body) => httpClient.post(`Address?custid=${id}`, body);
const Location = (body) => httpClient.post(`PostLocation`, body);
const postManualVisit = (body) =>
  httpClient.post(`RegisterManualVisit/manual-visit`, body);
const getOrderById = (id) => httpClient.get(`Orders/${id}`);
const repeatFactor = (id) => httpClient.post(`CopyPreviousOrder?orderId=${id}`);
const getStatus = () => httpClient.get(`ScheduleStatuses`);
const getProducts = (id) => httpClient.get(`Orders/${id}`);
const getCustomer = (MeliCode) =>
  httpClient.get(`CustomerByMeliCode?MeliCode=${MeliCode}`);
const updateStatus = (sid, description, stateid) =>
  httpClient.post(
    `ScheduleStateUpdate?sid=${sid}&description=${description}&stateid=${stateid}`
  );
const searchProduct = (q, anbar, custid) =>
  httpClient.get(`ProductSearch?q=${q}&anbar=${anbar}&custid=${custid}`);
const getProduct = (id, custid, anbar) =>
  httpClient.get(`Category/${id}?custid=${custid}&anbar=${anbar}`);
const postShoppingCart = (cart) => httpClient.post(`ShoppingCart`, cart);
const postCustomer = (customer) => httpClient.post(`CreateCustomer`, customer);
const searchCustomer = (searchTerm, pageNumber) =>
  httpClient.get(
    `SearchCustomer?searchTerm=${searchTerm}&PageNumber=${pageNumber}&PageSize=5&IncludeCount=true`
  );

const getLocation = (lat, lng) =>
  AuthClient.get(`https://api.neshan.org/v5/reverse?lat=${lat}&lng=${lng}`, {
    headers: {
      "Api-Key": "service.7027dcf0790e4949bce44804ffccff20",
    },
  });
const convertToLocation = (ADDRESS) =>
  AuthClient.get(`https://api.neshan.org/v4/geocoding?address=${ADDRESS}`, {
    headers: {
      "Api-Key": "service.7027dcf0790e4949bce44804ffccff20",
    },
  });

export {
  login,
  schedule,
  getStatus,
  updateStatus,
  getCategory,
  getProduct,
  postShoppingCart,
  getOrders,
  getProducts,
  searchProduct,
  postCustomer,
  getCustomer,
  getOrderById,
  repeatFactor,
  getLocation,
  convertToLocation,
  getAddress,
  postAddress,
  getReportCustomer,
  updatePermissionOutput,
  searchCustomer,
  Location,
  postManualVisit,
};
